var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V10H21C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14H22V17C22 18.6569 20.6569 20 19 20H5C3.50743 20 2.26944 18.91 2.03861 17.4826C3.04163 17.8285 4.107 18 4.99999 18V18C4.99999 18 5 18 5 18H13.5V17.25C13.5 16.6977 13.9477 16.25 14.5 16.25C15.0523 16.25 15.5 16.6977 15.5 17.25V18H19C19.5523 18 20 17.5523 20 17V15.874C18.2748 15.4299 17 13.8638 17 12C17 10.1362 18.2748 8.57006 20 8.12602V7C20 6.44772 19.5523 6 19 6H15.5V6.75C15.5 7.30228 15.0523 7.75 14.5 7.75C13.9477 7.75 13.5 7.30228 13.5 6.75V6H5C4.44772 6 4 6.44772 4 7V8.12602C5.72523 8.57006 7 10.1362 7 12C7 13.8638 5.72523 15.4299 4 15.874V15.9165C3.35953 15.8157 2.67552 15.6241 2.07172 15.3433C2.04753 15.332 2.02362 15.3207 2 15.3093V14H3C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10H2V7ZM14.5 9.25C15.0523 9.25 15.5 9.69772 15.5 10.25V13.75C15.5 14.3023 15.0523 14.75 14.5 14.75C13.9477 14.75 13.5 14.3023 13.5 13.75V10.25C13.5 9.69772 13.9477 9.25 14.5 9.25Z",
    fill: "#001A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucher);
export default __webpack_public_path__ + "static/media/icon_voucher.8a99b9667177742385b855c18994d352.svg";
export { ForwardRef as ReactComponent };